import React from "react";

import { ReactComponent as LogoCall } from "../../../assets/icons/call-calling.svg";

const Footer = () => {
  return (
    <section
      className="flex w-full justify-center p-0 2xl:h-56"
      style={{ backgroundColor: "#0F0F0F" }}
    >
      <div className="container w-full justify-center py-10 text-whiteSoft lg:py-10 xl:px-10 2xl:px-20">
        <div className="mx-10 pb-10 lg:mx-0">
          <div className="mb-2 flex justify-center">
            <LogoCall className="mt-3 w-20" />
            <div className="ml-3">
              <p className="text-2xl font-medium">Necesita ayuda?</p>
              <p className="text-2xl font-medium">
                (601) 4898599 - 01 8000 411 720
              </p>
            </div>
          </div>
        </div>
        <div className="w-full border-t pt-2 text-center"></div>
      </div>
    </section>
  );
};

export default Footer;
